export type { AvatarProps } from "./avatar";
export { Avatar } from "./avatar";
